export const temporaryAccountPrefix = 'support+'; // this is a temporary prefix for the email address that we generated for the user
export const sessionExpiredMessage =
  'Error fetching required data. Your session might have expired. Please login again.';
